import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'

// 导入mint-ui组件库
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.min.css'
// 导入vant组件库
import Vant from 'vant'
import 'vant/lib/index.css'
// 导入全局样式
import './assets/scss/global.scss'
import './assets/css/common.css'
import './assets/scss/my-mint.scss'
import axios from 'axios'
// 导入bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import './utils/directive' // 引进自定义指令

import VueClipboard from 'vue-clipboard2'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
const hls = require('videojs-contrib-hls')

// 全局注册
Vue.use(preview)
Vue.use(Vant)
// 下拉刷新

import VueScroller from 'vue-scroller'
Vue.use(VueScroller)
// 配置基础URL
import wx from 'weixin-js-sdk';//引入
Vue.prototype.wx = wx
import noShare from './common/noShare'

Vue.use(noShare)
// 接口地址
axios.defaults.baseURL = process.env.VUE_APP_API_URL
// websocket地址
Vue.prototype.$wxBaseURL = process.env.VUE_APP_WEBSOCKET_URL
// axios.defaults.baseURL = 'http://live.mingyizhi.cn/w_s/'
// axios.defaults.baseURL = 'http://192.168.3.32/w_s/'
// Vue.prototype.$wxBaseURL = 'ws://192.168.3.32:7083/websocket/'
// Vue.prototype.$wxBaseURL = 'ws://live.mingyizhi.cn:8083/websocket/'
Vue.prototype.$http = axios
Vue.config.productionTip = false

Vue.use(MintUI)
Vue.use(VueWechatTitle)
Vue.use(VideoPlayer)
Vue.use(hls)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
